import { isLocalizable, ILocalizable } from "../localization";

export class AppError extends Error {
  public constructor(message: ILocalizable | string, error?: Error) {
    super(isLocalizable(message) ? message.messageId.value : message);

    if (error) {
      this.name = error.name;
      this.stack = error.stack;
    }
  }
}
